import { render, staticRenderFns } from "./EditableItineraryItem.vue?vue&type=template&id=229f754a&scoped=true&"
import script from "./EditableItineraryItem.vue?vue&type=script&lang=js&"
export * from "./EditableItineraryItem.vue?vue&type=script&lang=js&"
import style0 from "./EditableItineraryItem.vue?vue&type=style&index=0&id=229f754a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f754a",
  null
  
)

export default component.exports